import React, { FC } from 'react';
import { Typography } from '@components/atoms/Typography';

export interface ErrorMessagesProps {
    messages?: string[];
}

export const ErrorMessages: FC<ErrorMessagesProps> = ({ messages }) => {
    return (
        <>
            {messages?.map((message, index) => (
                <Typography classes="mb-0" key={`message-${index}`} fontSize="14" color="danger">
                    {message}
                </Typography>
            ))}
        </>
    );
};
